/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

import type { IntegrationModes } from './IntegrationModes';
import {
    IntegrationModesFromJSON,
    IntegrationModesFromJSONTyped,
    IntegrationModesToJSON,
    IntegrationModesToJSONTyped,
} from './IntegrationModes';
import type { Organization } from './Organization';
import {
    OrganizationFromJSON,
    OrganizationFromJSONTyped,
    OrganizationToJSON,
    OrganizationToJSONTyped,
} from './Organization';

/**
 * 
 * @export
 * @interface ModelConfiguration
 */
export interface ModelConfiguration  {
    /**
     * 
     * @type {string}
     * @memberof ModelConfiguration
     */
    sandbox_client_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelConfiguration
     */
    sandbox_client_secret?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelConfiguration
     */
    sandbox_read_public_token?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelConfiguration
     */
    sandbox_webhook_token?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelConfiguration
     */
    sandbox_redirect_url?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelConfiguration
     */
    sandbox_webhook_url?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelConfiguration
     */
    sandbox_mms_entry_url?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelConfiguration
     */
    client_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelConfiguration
     */
    client_secret?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelConfiguration
     */
    read_public_token?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelConfiguration
     */
    webhook_token?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelConfiguration
     */
    redirect_url?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelConfiguration
     */
    webhook_url?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelConfiguration
     */
    mms_entry_url?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelConfiguration
     */
    organization_url?: string;
    /**
     * 
     * @type {Organization}
     * @memberof ModelConfiguration
     */
    organization?: Organization;
    /**
     * 
     * @type {string}
     * @memberof ModelConfiguration
     */
    contact_mail?: string;
    /**
     * 
     * @type {IntegrationModes}
     * @memberof ModelConfiguration
     */
    integrationModes?: IntegrationModes;
    /**
     * 
     * @type {boolean}
     * @memberof ModelConfiguration
     */
    sandbox?: boolean;
}

/**
 * Check if a given object implements the ModelConfiguration interface.
 */
export function instanceOfModelConfiguration(value: object): value is ModelConfiguration {
    return true;
}

export function ModelConfigurationFromJSON(json: any): ModelConfiguration {
    return ModelConfigurationFromJSONTyped(json, false);
}

export function ModelConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ModelConfiguration {
    if (json == null) {
        return json;
    }
    return {
        
                  'sandbox_client_id': json['sandbox_client_id'] == null ? undefined : json['sandbox_client_id'],
                  'sandbox_client_secret': json['sandbox_client_secret'] == null ? undefined : json['sandbox_client_secret'],
                  'sandbox_read_public_token': json['sandbox_read_public_token'] == null ? undefined : json['sandbox_read_public_token'],
                  'sandbox_webhook_token': json['sandbox_webhook_token'] == null ? undefined : json['sandbox_webhook_token'],
                  'sandbox_redirect_url': json['sandbox_redirect_url'] == null ? undefined : json['sandbox_redirect_url'],
                  'sandbox_webhook_url': json['sandbox_webhook_url'] == null ? undefined : json['sandbox_webhook_url'],
                  'sandbox_mms_entry_url': json['sandbox_mms_entry_url'] == null ? undefined : json['sandbox_mms_entry_url'],
                  'client_id': json['client_id'] == null ? undefined : json['client_id'],
                  'client_secret': json['client_secret'] == null ? undefined : json['client_secret'],
                  'read_public_token': json['read_public_token'] == null ? undefined : json['read_public_token'],
                  'webhook_token': json['webhook_token'] == null ? undefined : json['webhook_token'],
                  'redirect_url': json['redirect_url'] == null ? undefined : json['redirect_url'],
                  'webhook_url': json['webhook_url'] == null ? undefined : json['webhook_url'],
                  'mms_entry_url': json['mms_entry_url'] == null ? undefined : json['mms_entry_url'],
                  'organization_url': json['organization_url'] == null ? undefined : json['organization_url'],
                  'organization': json['organization'] == null ? undefined : OrganizationFromJSON(json['organization']),
                  'contact_mail': json['contact_mail'] == null ? undefined : json['contact_mail'],
                  'integrationModes': json['integrationModes'] == null ? undefined : IntegrationModesFromJSON(json['integrationModes']),
                  'sandbox': json['sandbox'] == null ? undefined : json['sandbox'],
    };
}

export function ModelConfigurationToJSON(json: any): ModelConfiguration {
    return ModelConfigurationToJSONTyped(json, false);
}

export function ModelConfigurationToJSONTyped(value?: ModelConfiguration | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'sandbox_client_id': value['sandbox_client_id'],
        'sandbox_client_secret': value['sandbox_client_secret'],
        'sandbox_read_public_token': value['sandbox_read_public_token'],
        'sandbox_webhook_token': value['sandbox_webhook_token'],
        'sandbox_redirect_url': value['sandbox_redirect_url'],
        'sandbox_webhook_url': value['sandbox_webhook_url'],
        'sandbox_mms_entry_url': value['sandbox_mms_entry_url'],
        'client_id': value['client_id'],
        'client_secret': value['client_secret'],
        'read_public_token': value['read_public_token'],
        'webhook_token': value['webhook_token'],
        'redirect_url': value['redirect_url'],
        'webhook_url': value['webhook_url'],
        'mms_entry_url': value['mms_entry_url'],
        'organization_url': value['organization_url'],
        'organization': OrganizationToJSON(value['organization']),
        'contact_mail': value['contact_mail'],
        'integrationModes': IntegrationModesToJSON(value['integrationModes']),
        'sandbox': value['sandbox'],
    };
}


